import { render, staticRenderFns } from "./BotAvatar.vue?vue&type=template&id=794b8f9f&scoped=true&"
import script from "./BotAvatar.vue?vue&type=script&lang=js&"
export * from "./BotAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b8f9f",
  null
  
)

export default component.exports